export default __webpack_public_path__ + "static/media/Blob.97682743.svg";